import { render, staticRenderFns } from "./Complements.vue?vue&type=template&id=398334ec"
import script from "./Complements.vue?vue&type=script&lang=js"
export * from "./Complements.vue?vue&type=script&lang=js"
import style0 from "./Complements.vue?vue&type=style&index=0&id=398334ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports